import { getStore } from '../store/store';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('setAllAllowedSubCategoriesLoaded', function setIsFullOptionsShown(
    newValue: boolean
) {
    getStore().areAllAllowedSubCategoriesLoaded = newValue;
});
